// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sheet-aggregate-tile{color:#1a1a1a;font-size:16px}.sheet-aggregate-tile .source-sit-id{display:flex;flex-direction:column}.sheet-aggregate-tile .source-sit-id .id{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
